import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { fetchMeta, fetchTopicData, setTopic } from './redux/dashboardActions';
import FeedbackEstabelecimentos from './componentes/feedbackestabelecimentos';
import FeedbackEmpresas from './componentes/feedbackempresas';
import FeedbackProdutos from './componentes/feedbackprodutos';
import AssuntoEmpresas from './componentes/assuntoempresas';
import AssuntoEstabelecimentos from './componentes/assuntoestabelecimentos';
import AssuntoProdutos from './componentes/assuntoprodutos';
import Swot from './componentes/swot';
import Plano7dias from './componentes/plano7dias';
import Plano30dias from './componentes/plano30dias';
import CsatRedes from './componentes/csatredes';
import NpsInd from './componentes/npsind';
import CsatConcorrentesRedes from './componentes/csatconcorrentesredes';
import NpsConcorrentesRedes from './componentes/npsconcorrentesredes';
import CsatCliente from './componentes/csatcliente';
import NpsCliente from './componentes/npscliente';
import CsatConcorrentes from './componentes/csatconcorrentes';
import NpsConcorrentes from './componentes/npsconcorrentes';
import CsatEstabelecimento from './componentes/csatestabelecimento';
import NpsEstabelecimento from './componentes/npsestabelecimento';
import CsatConcorrentesEstabelecimento from './componentes/csatconcorrentesestabelecimento';
import NpsConcorrentesEstabelecimento from './componentes/npsconcorrentesestabelecimento';
import NpsConcorrentesProdutos from './componentes/npsconcorrentesprodutos';
import CsatConcorrentesProdutos from './componentes/csatconcorrentesprodutos';
import CsatClienteProdutos from './componentes/csatclienteprodutos';
import NpsClienteProdutos from './componentes/npsclienteprodutos';
import IndicadoresRedes from './componentes/indicadoresredes';

import './dashboard.scss';
import { IcoStar, Select, IcoCalendarPlano, PopoverCentralAjuda } from '../../components';
import { IcoGlobo } from '../../components/icon/custom/icoglobo';

// Assets
import imgLogo from '../../layout/img/logo-yellow.png';
import imgCover from './assets/logodashboard.png';
import CentralAjudaPublicHost from './CentralAjudaPublicHost';




const COMPONENTS_MAP = {
  feedbackestabelecimentos: FeedbackEstabelecimentos,
  feedbackempresas: FeedbackEmpresas,
  feedbackprodutos: FeedbackProdutos,
  assuntoempresas: AssuntoEmpresas,
  assuntoestabelecimentos: AssuntoEstabelecimentos,
  assuntoprodutos: AssuntoProdutos,
  swot: Swot,
  plano7dias: Plano7dias,
  plano30dias: Plano30dias,
  csatredes: CsatRedes,
  npsredes: NpsInd,
  csatconcorrentesredes: CsatConcorrentesRedes,
  npsconcorrentesredes: NpsConcorrentesRedes,
  csatcliente: CsatCliente,
  npscliente: NpsCliente,
  csatconcorrentes: CsatConcorrentes,
  npsconcorrentes: NpsConcorrentes,
  csatestabelecimento: CsatEstabelecimento,
  npsestabelecimento: NpsEstabelecimento,
  csatconcorrentesestabelecimento: CsatConcorrentesEstabelecimento,
  npsconcorrentesestabelecimento: NpsConcorrentesEstabelecimento,
  npsconcorrentesprodutos: NpsConcorrentesProdutos,
  csatconcorrentesprodutos: CsatConcorrentesProdutos,
  csatclienteprodutos: CsatClienteProdutos,
  npsclienteprodutos: NpsClienteProdutos,
  indicadoresredes: IndicadoresRedes,
};

export default function DashboardPublicPage() {
  const { id } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const requestedTopic = query.get('topic');

  const dispatch = useDispatch();
  const { loading, error, notFound, meta, topic, payload } = useSelector(
    (s) => s.dashboard || s.dashboardState
  );

  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const [showCover, setShowCover] = useState(true);
  const [topicLoadError, setTopicLoadError] = useState(false);

  // 🔁 Carrega NLS global (primeiro carrega pt-BR como fallback)
  let nls;
  try {
    nls = require('./nls/pt-BR.json');
  } catch (e) {
    console.warn('NLS pt-BR não encontrado.', e);
    nls = { 
      loading: 'Carregando...', 
      dashboardNotFound: 'Dashboard não encontrado',
      dashboardUnavailable: 'Dashboard indisponível',
      openDashboard: 'Abrir Dashboard',
      scheduleDemo: 'Agendar demonstração',
      createAccount: 'Criar conta',
      topic: 'Tópico',
      video: 'Vídeo',
      closeVideo: 'Fechar vídeo',
      loadingContent: 'Carregando conteúdo...',
      topicUnavailable: 'Conteúdo do tópico indisponível',
      unsupportedComponent: 'Componente não suportado'
    };
  }

  // Se tiver meta, usar o idioma dela
  let idioma = 'pt-BR';
  if (meta?.idioma) {
    idioma = meta.idioma;
    try {
      nls = require(`./nls/${idioma}.json`);
    } catch (e) {
      console.warn(`Idioma '${idioma}' não encontrado. Usando pt-BR.`, e);
    }
  }

    // 🔁 Carrega NLS da Central de Ajuda (mesmo idioma do dashboard)
  let nlsContexto;
  try {
    nlsContexto = require(`../centralAjuda/nlscontexto/${idioma}.json`);
  } catch (e) {
    console.warn(`nlsContexto '${idioma}' não encontrado. Usando pt-BR.`, e);
    try {
      nlsContexto = require(`../centralAjuda/nlscontexto/pt-BR.json`);
    } catch (e2) {
      console.warn('nlsContexto pt-BR não encontrado.', e2);
      nlsContexto = {};
    }
  }



  const youtubeId = meta?.youtubeid?.trim() || null;

  const deveMostrarLogoConsultor =
  meta?.ehContaConsultor === true && !!meta?.logoConsultor;

  const srcLogoConsultor = deveMostrarLogoConsultor
    ? `/consultores/${meta.logoConsultor}`
    : null;

  const logoPrincipalCapa = deveMostrarLogoConsultor
    ? srcLogoConsultor
    : imgCover;


  useEffect(() => {
    if (!id) return;
    (async () => {
      const m = await dispatch(fetchMeta(id));
      if (!m) return;
      const allowed = (m.topics || []).map(t => t.key);
      const chosen = allowed.includes(requestedTopic) ? requestedTopic : (allowed[0] || null);
      if (chosen) {
        dispatch(setTopic(chosen));
        try {
          await dispatch(fetchTopicData(id, chosen));
          setTopicLoadError(false);
        } catch (err) {
          setTopicLoadError(true);
        }
      }
    })();
  }, [id, dispatch, requestedTopic]);


    useEffect(() => {
    if (!showCover && youtubeId && !isVideoVisible) {
      setIsVideoVisible(true);
    }
  }, [showCover, youtubeId]);


  const handleTopicChange = async (event) => {
    const selectedTopicKey = event?.value?.key;
    if (selectedTopicKey) {
      setTopicLoadError(false);
      dispatch(setTopic(selectedTopicKey));
      try {
        await dispatch(fetchTopicData(id, selectedTopicKey));
        setTopicLoadError(false);
      } catch (err) {
        setTopicLoadError(true);
      }
    }
  };

  const handleOpenDashboard = () => {
    setShowCover(false);
    
  };

  // 👇 VERIFICAÇÃO DE DASHBOARD NÃO ENCONTRADO (deve vir ANTES da verificação de meta)
  
  /*  Desativado porque não dá para sabe idioma do usuário, então apenas redirecionamos para a página do app
  if (notFound) {
    return (
      <div className="dash-root">
        <div className="dash-cover">
          <div className="dash-status dash-notfound" style={{ 
            textAlign: 'center', 
            padding: '40px 20px',
            fontSize: '18px',
            color: 'white'
          }}>
            {nls.dashboardNotFound}
          </div>  
        </div>
      </div>
    );
  }
  */

  if (notFound) {
  // Redireciona imediatamente para app.yellowtokens.com
  window.location.href = 'https://app.yellowtokens.com';
  return null; // Retorna null para não renderizar nada
}

  


  // 🌀 Tela de carregamento inicial APENAS se ainda está carregando e não tem erro
  if (loading && !meta && !error) {
    return (
      <div className="dash-root">
        <div className="dash-cover">
          <div className="loading-spinner"></div>
          <div style={{ marginTop: '16px' }}>{nls.loading}</div>
        </div>
      </div>
    );
  }

  // 👇 ERRO GERAL DO DASHBOARD
  if (error && !meta) {
    return (
      <div className="dash-root">
        <div className="dash-cover">
          <div className="dash-status" style={{ 
            textAlign: 'center', 
            padding: '40px 20px',
            fontSize: '18px',
            color: 'white'
          }}>
            {nls.dashboardUnavailable}
          </div>
        </div>
      </div>
    );
  }

  // 👇 CAPA INICIAL (só mostra se não houver erro e se showCover for true)
  if (showCover && meta) {
    return (
      <div className="dash-root">
        <div className="dash-cover">
          <div className="dash-cover__content">
            <img
              src={logoPrincipalCapa}
              alt={deveMostrarLogoConsultor ? "Logo Consultor" : "Yellow Tokens Dashboard"}
              className="dash-cover__logo"
            />

            <div className="dash-cover__dashboard-text">Dashboard</div>
            <h1 className="dash-cover__title">{meta.titulo}</h1>
            <p className="dash-cover__period">{meta.periodoanalisado}</p>

            {meta.autor && meta.autor.trim() && (
              <p className="dash-cover__author">{meta.autor}</p>
            )}

            <button onClick={handleOpenDashboard} className="dash-cover__open-btn">
              <span>{nls.openDashboard}</span>
              <span className="dash-cover__arrow"></span>
            </button>

            {deveMostrarLogoConsultor ? (
              <div className="dash-cover__powered-by">
                <span>Powered by</span>
                <img
                  src={imgCover}
                  alt="Yellow Tokens"
                  className="dash-cover__powered-logo"
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  // 👇 SE NÃO TEM META E NÃO ESTÁ CARREGANDO E NÃO É NOTFOUND
  if (!meta) {
    return (
      <div className="dash-root">
        <div className="dash-cover">
          <div className="dash-status" style={{ 
            textAlign: 'center', 
            padding: '40px 20px',
            fontSize: '18px',
            color: 'white'
          }}>
            {nls.dashboardUnavailable}
          </div>
        </div>
      </div>
    );
  }

  // 👇 PÁGINA PRINCIPAL DO DASHBOARD (só chega aqui se meta existir)
  const topicOptions = meta.topics || [];
  const selectedOption = topicOptions.find(t => t.key === topic) || null;


    // 🆘 Central de Ajuda por tópico (somente os que têm help)
  const HELP_BY_TOPIC = {
    swot: [316],

    csatredes: [312],
    npsredes: [313],
    csatconcorrentesredes: [314],
    npsconcorrentesredes: [315],

    csatcliente: [300],
    npscliente: [301],
    csatconcorrentes: [302],
    npsconcorrentes: [303],

    csatestabelecimento: [304],
    npsestabelecimento: [305],
    csatconcorrentesestabelecimento: [306],
    npsconcorrentesestabelecimento: [307],

    npsconcorrentesprodutos: [311],
    csatconcorrentesprodutos: [310],
    csatclienteprodutos: [308],
    npsclienteprodutos: [309],
  };

  const idarrayAjuda = topic ? HELP_BY_TOPIC[topic] : null;
  const hasAjuda = Array.isArray(idarrayAjuda) && idarrayAjuda.length > 0;


  return (
    <div className="dash-root">
      {/* TESTEIRA */}
      <div className="dash-topbar">
        <div className="dash-topbar__container">
                 
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowCover(true);
            }}
            className="dash-topbar__logo-link"
          >
            <img src={imgLogo} alt="Yellow Tokens" className="dash-topbar__logo" />

            {deveMostrarLogoConsultor ? (
              <img
                src={srcLogoConsultor}
                alt="Logo Consultor"
                className="dash-topbar__logo-consultor"
              />
            ) : null}
          </a>

          <div className="dash-topbar__actions">
            <a
              href="https://calendly.com/bruno-yellowtokens/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="dash-topbar__schedule-demo"
            >
              {nls.scheduleDemo}
            </a>
            <a
              href="https://app.yellowtokens.com/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="dash-topbar__signup-text"
            >
              {nls.createAccount}
            </a>
            <a
              href={nls.websiteUrl || 'https://yellowtokens.com'}
              target="_blank"
              rel="noopener noreferrer"
              className="dash-topbar__website-link"
              aria-label="Visite o site da Yellow Tokens"
            >
              <IcoGlobo style={{ width: 20, height: 20 }} />
            </a>
          </div>
        </div>
      </div>

      {/* CONTAINER COM SCROLL */}
      <div className="dash-scroll-container">
        <div className="dash-wrap">
          {/* BLOCO DO SELETOR DE TÓPICO - SEMPRE VISÍVEL */}
          <div className="box-swot-search box-content">
            <div className="box-swot-search-box">
              <div className="box-swot-search-type" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <p style={{ margin: 0 }}>{nls.topic}</p>
                <IcoCalendarPlano style={{ width: 20, height: 20 }} />
              </div>

              <div className="box-swot-search-select">

              <div className="box-swot-search-select__control">
                <Select
                  key={topic || 'initial'}
                  name="topico"
                  options={topicOptions}
                  selected={selectedOption}
                  action={handleTopicChange}
                  optionLabel="label"
                  optionValue="key"
                  selectedItem={false}
                  labelCustom={(e) =>
                    e?.label
                      ? <>{e.label}</>
                      : <span style={{ display: 'inline-block', minWidth: '60px' }}>&nbsp;</span>
                  }
                />
              </div>

              {hasAjuda && (
                <div className="dash-topic-help">
                  <PopoverCentralAjuda
                    nlsContexto={nlsContexto}
                    idarray={idarrayAjuda}
                  />
                </div>
              )}

            </div>

            </div>

            {youtubeId && (
              <div className="box-swot-search-action">
                <div className="video-tutorial-wrapper">
                  <button
                    type="button"
                    className="video-tutorial"
                    title="Assista ao vídeo explicativo"
                    aria-label="Vídeo explicativo"
                    onClick={() => setIsVideoVisible(!isVideoVisible)}
                  >
                    <svg className="video-tutorial__icon" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                      <path fill="currentColor" d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm-2 6.5 7 3.5-7 3.5V8.5z"/>
                    </svg>
                    <span>{isVideoVisible ? nls.closeVideo : nls.video}</span>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* CONTEÚDO DO TÓPICO SELECIONADO */}
          {topic ? (
            <section className="dash-content">
              <div className="dash-content-inner">
                {(() => {
                  // Se há erro específico no carregamento deste tópico
                  if (topicLoadError) {
                    return (
                      <div className="dash-status">
                        {nls.topicUnavailable}
                      </div>
                    );
                  }

                  // Se está carregando
                  if (loading) {
                    return <div className="dash-status">{nls.loadingContent}</div>;
                  }

                  // Se não há payload
                  if (!payload) {
                    return <div className="dash-status">{nls.topicUnavailable}</div>;
                  }

                  const Component = COMPONENTS_MAP[topic];
                  if (!Component) {
                    return <div className="dash-status">{nls.unsupportedComponent}</div>;
                  }

                  const activeComponent = meta?.components?.find(c => c.topicKey === topic);
                  const componentNls = activeComponent?.nls || {};

                  return (
                    <Component
                      title={payload.titulo}
                      escopo={payload.escopo}
                      items={payload.data?.items || []}
                      nls={nls}
                      componentNls={payload.nls}
                      autor={payload.autor}
                      filtros={payload.filtros || []}
                      payloadData={payload.data}
                      totaldata={payload.totaldata}
                    />
                  );
                })()}
              </div>
            </section>
          ) : (
            // Estado inicial - nenhum tópico selecionado
            <div className="dash-content">
              <div className="dash-status">{nls.loadingContent}</div>
            </div>
          )}

          {/* PLAYER FLUTUANTE */}
          {isVideoVisible && youtubeId && (
            <div className="dashboard-video-floating">
              <div className="dashboard-video-header">
                <button 
                  className="dashboard-video-close" 
                  onClick={() => setIsVideoVisible(false)}
                >
                  ×
                </button>
              </div>
              <iframe
                width="320"
                height="180"
                //src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
                src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&rel=0&playsinline=1`}
                title="Vídeo explicativo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </div>
      </div>

      <CentralAjudaPublicHost idioma={idioma} />

    </div>
  );
}

